module.exports = __webpack_public_path__ + "img/litterAfsorder.6ba3bb42.svg";